import { FC } from "react";
import { Box, Skeleton } from "@mui/material";
import { muiTheme } from "@/styles/theme";
import NotificationCardSkeleton from "./notification-card-skeleton";

interface Props {
  count?: number;
}

const NotificationSkeletonList: FC<Props> = ({ count = 6 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <Box key={i}>
          {i % 3 === 0 && (
            <Box
              sx={{
                width: "100%",
                backgroundColor:
                  muiTheme.colorSchemes.light.palette.background.offwhite,
                px: "26px",
                py: "12px",
              }}
            >
              <Skeleton variant="text" width="150px" height={24} />
            </Box>
          )}

          <NotificationCardSkeleton />
        </Box>
      ))}
    </>
  );
};

export default NotificationSkeletonList;
